import ExportToPDF from "./export-to-pdf";

export default ExportToPDF;